export const ANIMAL_GROUP_OPTIONS = Object.freeze([
  ["livestock", "Domestic & Food Production"],
  ["wildlife", "Wildlife"],
]);

export const ANIMAL_STATUS_OPTIONS = Object.freeze([
  ["sick", "Sick"],
  ["dead", "Dead"],
]);

export const FARM_ANIMAL_SPECIES = Object.freeze([
  { label: "Poultry (chickens, turkeys, ducks, geese)", type: "bird" },
  { label: "Cattle (beef and dairy)", type: "mammal" },
  { label: "Swine", type: "mammal" },
  { label: "Sheep and goats", type: "mammal" },
  { label: "Horses and equids", type: "mammal" },
  { label: "Camelids (llamas, alpacas)", type: "mammal" },
  { label: "Other livestock", type: "other" },
]);

export const WILDLIFE_SPECIES = Object.freeze([
  { label: "Bats", type: "mammal" },
  { label: "Wild rodents in / near buildings", type: "mammal" },
  { label: "Wild birds (waterfowl, raptors)", type: "bird" },
  { label: "Wild carnivores (foxes, skunks, coyotes)", type: "mammal" },
  { label: "Deer and elk", type: "mammal" },
  { label: "Other wildlife", type: "other" },
]);

export const ANIMAL_REPORTER_FEELING_OPTIONS = Object.freeze([
  ["good", "Healthy"],
  ["sick", "Sick"],
  ["prefer_not_say", "Would rather not say"],
]);

export function animalSpeciesOptions(animalGroup) {
  if (animalGroup === "livestock") return FARM_ANIMAL_SPECIES;
  if (animalGroup === "wildlife") return WILDLIFE_SPECIES;
  return [];
}

export function animalStatusOptions(animalGroup) {
  if (animalGroup === "wildlife") return ANIMAL_STATUS_OPTIONS.filter(([value]) => value === "dead");
  if (animalGroup === "livestock") return ANIMAL_STATUS_OPTIONS;
  return [];
}

export function animalTypeForSpecies(animalGroup, speciesLabel) {
  const option = animalSpeciesOptions(animalGroup).find((species) => species.label === speciesLabel);
  return option?.type || "";
}

export function activeAnimalCountField(animalStatus) {
  if (animalStatus === "sick") return "animalSickCount";
  if (animalStatus === "dead") return "animalDeadCount";
  return "";
}

export function isAnimalFoundDateInRange(value, today = new Date()) {
  const foundDate = parseLocalIsoDate(value);
  if (!foundDate) return false;
  const currentDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const earliestDay = new Date(currentDay);
  earliestDay.setDate(currentDay.getDate() - 28);
  return foundDate >= earliestDay && foundDate <= currentDay;
}

function parseLocalIsoDate(value) {
  const match = String(value || "").trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  const year = Number.parseInt(match[1], 10);
  const month = Number.parseInt(match[2], 10) - 1;
  const day = Number.parseInt(match[3], 10);
  const date = new Date(year, month, day);
  if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) return null;
  return date;
}
